var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook-circular-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.125,
    height: 30,
    viewBox: "0 0 30.125 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M15.063.349a15.055,15.055,0,0,0-2.512,29.9V18.554H8.917V14.346h3.634v-3.1c0-3.6,2.2-5.562,5.411-5.562a29.987,29.987,0,0,1,3.244.165V9.609H18.978c-1.747,0-2.083.83-2.083,2.048v2.686h4.167l-.544,4.208H16.9v11.8a15.056,15.056,0,0,0-1.832-30Z",
    transform: "translate(0 -0.349)",
    fill: "#29a2ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogin);
export default __webpack_public_path__ + "static/media/facebookLogin.877d814f87ad76486f3dd1e563271fda.svg";
export { ForwardRef as ReactComponent };